/* SISTER NY custom storefront behavior. */


(function() {
  function initScrollTop() {
    var button = document.querySelector('[data-scroll-top-button]');
    if (!button) return;

    var progress = button.querySelector('.sny-scroll-top__progress');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function update() {
      var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var percent = Math.min(1, window.scrollY / scrollable);
      if (progress) progress.style.strokeDashoffset = String(100 * (1 - percent));
      var visible = window.scrollY > Math.min(600, window.innerHeight * 0.7);
      button.classList.toggle('is-visible', visible);
      button.tabIndex = visible ? 0 : -1;
    }

    button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.scrollTo({ top: 0, left: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }, true);

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initOfferTeaser() {
    var hero = document.querySelector('.template-index [id$="__hero"]');
    var footer = document.querySelector('.footer-sections');
    var footerVisible = false;

    function updateOffer() {
      var heroPassed = !hero || hero.getBoundingClientRect().bottom <= 0;
      document.body.classList.toggle('sny-offer-visible', heroPassed);
      document.body.classList.toggle('sny-footer-visible', footerVisible);
    }

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        footerVisible = entries[0].isIntersecting;
        updateOffer();
      }, { threshold: 0 }).observe(footer);
    } else if (footer) {
      function checkFooter() {
        var rect = footer.getBoundingClientRect();
        footerVisible = rect.top < window.innerHeight && rect.bottom > 0;
        updateOffer();
      }
      window.addEventListener('scroll', checkFooter, { passive: true });
      window.addEventListener('resize', checkFooter, { passive: true });
      checkFooter();
    }

    window.addEventListener('scroll', updateOffer, { passive: true });
    window.addEventListener('resize', updateOffer, { passive: true });
    updateOffer();
  }

  function initEditorialMediaReveal() {
    var media = Array.prototype.slice.call(document.querySelectorAll(
      '.template-index [id$="__editorial"] .brick__block:first-child, ' +
      '.sny-story__opening-image, .sny-story__image'
    ));
    if (!media.length) return;

    media.forEach(function(element) { element.classList.add('sny-pop-media'); });
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      media.forEach(function(element) { element.classList.add('is-open'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        entry.target.classList.toggle('is-open', entry.isIntersecting);
      });
    }, { threshold: 0.16, rootMargin: '-4% 0px -4% 0px' });
    media.forEach(function(element) { observer.observe(element); });
  }

  function initContinuousHeroAutoplay() {
    var slider = document.querySelector('.template-index [id$="__hero"] slider-component[data-slider]');
    if (!slider) return;

    var attempts = 0;
    function connect() {
      var flickity = slider.flkty;
      if (!flickity) {
        attempts += 1;
        if (attempts < 50) window.setTimeout(connect, 100);
        return;
      }
      if (slider.dataset.snyContinuousAutoplay === 'true') return;
      slider.dataset.snyContinuousAutoplay = 'true';

      flickity.options.pauseAutoPlayOnHover = false;
      if (typeof flickity.off === 'function') {
        flickity.off('uiChange', flickity.stopPlayer);
        flickity.off('pointerDown', flickity.stopPlayer);
      }

      function resume() {
        if (flickity.options.autoPlay) flickity.playPlayer();
      }

      ['mouseenter', 'mouseleave', 'pointerdown', 'pointerup', 'touchend', 'focusin', 'focusout'].forEach(function(eventName) {
        slider.addEventListener(eventName, resume, { passive: true });
      });
      slider.addEventListener('theme:slider:select', function() {
        window.setTimeout(resume, 0);
      });
      resume();
    }

    slider.addEventListener('theme:slider:loaded', connect);
    connect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initScrollTop();
      initOfferTeaser();
      initEditorialMediaReveal();
      initContinuousHeroAutoplay();
    }, { once: true });
  } else {
    initScrollTop();
    initOfferTeaser();
    initEditorialMediaReveal();
    initContinuousHeroAutoplay();
  }
})();
